import Loadable from 'react-loadable';

export const SettingsView = Loadable({
  loader: () => import(/* webpackChunkName: "SettingsView" */ './components/SettingsView'),
  loading: () => null,
});

export { settingsPageResource } from './resources/settings';
